import { render, staticRenderFns } from "./AccountGroupList.vue?vue&type=template&id=229059b6&scoped=true"
import script from "./AccountGroupList.vue?vue&type=script&lang=js"
export * from "./AccountGroupList.vue?vue&type=script&lang=js"
import style0 from "./AccountGroupList.vue?vue&type=style&index=0&id=229059b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229059b6",
  null
  
)

export default component.exports